import Icon from 'components/atoms/Icon';
import { useTranslation } from 'helpers/useTranslation';
import { OrderStatus as StatusHolder } from 'styles/helpers.styles';

export function OrderStatus({ order }) {
  const { t } = useTranslation();
  const resellerType = order?.resellerId?.typeOfAuthorizedCenter;

  const handleStatus = status => {
    if ((resellerType === 'standard' || resellerType === 'basic') && status === 'accepted') {
      return t('Accepted & Paid');
    }
    if (status === 'comission_paid') {
      return t('Comission Paid');
    }
    return t(status);
  };

  return (
    <div>
      <StatusHolder>
        <span>{handleStatus(order?.status)}</span>
        {order.status === 'created' && (
          <Icon showTooltip toolTipContent={t('Created')} iconName="radio_button_checked" />
        )}
        {order.status === 'cancelled' && <Icon showTooltip toolTipContent={t('Cancelled')} iconName="cancel" />}
        {order.status === 'accepted' && <Icon showTooltip toolTipContent={t('Accepted')} iconName="check_circle" />}
        {order.status === 'pending' && <Icon showTooltip toolTipContent={t('Pending')} iconName="settings" />}
        {order.status === 'paid' && <Icon showTooltip toolTipContent={t('Paid')} iconName="paid" />}
        {order.status === 'comission_paid' && <Icon showTooltip toolTipContent={t('Comission Paid')} iconName="paid" />}
      </StatusHolder>
    </div>
  );
}
